import { render } from "./DashboardAPTFiltersOld.vue?vue&type=template&id=baeaff46"
import script from "./DashboardAPTFiltersOld.vue?vue&type=script&lang=js"
export * from "./DashboardAPTFiltersOld.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__